import React, { useState, useEffect } from "react";
import MainBody from "../../../component/MainBody";
import httpRequest from "../../../utils/Http";
import Select from "react-select";
import { getdropdownList, openSignUrl } from "../../../utils/HelperFunction";
import {
  LABEL_APPLIACE_NAME,
  LABEL_BRAND,
  LABEL_JOB,
} from "../../../constant/label_constant";
import { NavLink } from "react-router-dom";
import MyDataTable from "../../../component/MyDataTable";
import moment from "moment";
import { useSelector } from "react-redux";
import { SF_ACTION_PERMISSION } from "../../../constant/action_permission";
import AssignVendor from "./AssignVendor";
import AssignEngineer from "../../serviceCenter/AssignEngineer";
import {
  EMPLOYEE_TYPE,
  PARTNER_TYPE,
  SF_TYPE,
} from "../../../constant/status_constant";
import CustomerPickDrop from "./CustomerPickDrop";
import "./UnAssignBooking.css";

const ApplianceDroppedASC = () => {
  // const [isSubmit, setSubmit] = useState(false);
  const [formData, setFormData] = useState({
    partner_id: "",
    appliance_id: "",
    state_id: "",
    calltype_id: "",
    order_by: "DESC",
  });
  const [stateList, setStateList] = useState([]);
  const [partnerlist, setPartnerlist] = useState([]);
  const [appliancelist, setApplianceList] = useState([]);
  const [calltypelist, setCalltypeList] = useState([]);
  const [formErrors, setFormErrors] = useState({});
  const [reloadList, setReload] = useState(true);
  const [isFilterOpen, setisFilterOpen] = useState(false);
  const [isOpenForm, setOpenForm] = useState(false);
  const [isNonHomeVisit, setNonHomeVisit] = useState(0);
  const [isEngOpenForm, setEngOpenForm] = useState(false);
  const [bid, setBid] = useState(null);
  const sortFilter = [
    {
      label: "Newest To Oldest Booking",
      value: "DESC",
    },
    {
      label: "Oldest To Newest Booking",
      value: "ASC",
    },
  ];
  let loggedInUser = useSelector((state) => state.authReducer.currentUser);

  const closeForm = () => {
    setOpenForm(false);
    setEngOpenForm(false);
    setNonHomeVisit(0);
  };

  useEffect(() => {
    (async () => {
      const state = await httpRequest("getallstatelist", {}, "GET");
      //console.log(partners);
      if (state.status === true && state.message) {
        setStateList(state.message);
      } else {
        setStateList([]);
      }

      const partners = await httpRequest(
        "getpartnerlist?is_active=1",
        {},
        "GET",
      );
      //console.log(partners);
      if (partners.status === true && partners.data) {
        setPartnerlist(partners.data["rows"]);
      }
      const appliance = await httpRequest(
        "getappliancelist?isactive=1",
        {},
        "GET",
      );
      //console.log(partners);
      if (appliance.status === true && appliance.data) {
        setApplianceList(appliance.data["rows"]);
      }

      getdropdownList(setCalltypeList, "getcalltypegrouplist?is_active=1");
    })();
    //eslint-disable-next-line
  }, []);

  useEffect(() => {
    if (
      loggedInUser &&
      loggedInUser.entity_type &&
      loggedInUser.entity_type === PARTNER_TYPE
    ) {
      setFormData({
        ...formData,
        partner_id: loggedInUser.entity_id,
      });
    }
  }, [loggedInUser]);
  const FilterComponent = () => {
    return (
      <section className="content assign-booking-filter">
        <div className="container-fluid">
          <div className="card card-default">
            <div className="card-header">
              <h3 className="card-title">Filter</h3>
              <div
                className="card-tools"
                style={{ marginLeft: "auto" }}
                onClick={() => setisFilterOpen(false)}
                role="button"
                tabIndex={0}
                onKeyDown={(e) => {
                  if (e.key === "Enter" || e.key === " ")
                    setisFilterOpen(false);
                }}
              >
                <i className="fas fa-minus" aria-hidden="true"></i>
              </div>
            </div>
            <form id="addsubform" onSubmit={(e) => e.preventDefault()}>
              <div className="card-body">
                <div className="row">
                  {Number(loggedInUser.entity_type) !== PARTNER_TYPE && (
                    <div className="col-md-3">
                      <div className="form-group">
                        <label>
                          Partner{" "}
                          <span style={{ color: "red" }}>
                            {formErrors.partner_id}
                          </span>
                        </label>
                        <Select
                          name="partner_id"
                          menuPortalTarget={document.body}
                          menuPosition="fixed"
                          value={
                            partnerlist.find(
                              (option) => option.value === formData.partner_id,
                            ) || null
                          }
                          options={partnerlist}
                          onChange={(val) => {
                            setFormData({
                              ...formData,
                              partner_id: val.value,
                            });
                          }}
                        />
                      </div>
                    </div>
                  )}

                  <div className="col-md-2">
                    <div className="form-group">
                      <label>
                        Appliance{" "}
                        <span style={{ color: "red" }}>
                          {formErrors.appliance_id}
                        </span>
                      </label>
                      <Select
                        name="appliance_id"
                        menuPortalTarget={document.body}
                        menuPosition="fixed"
                        value={
                          appliancelist.find(
                            (option) => option.value === formData.appliance_id,
                          ) || null
                        }
                        options={appliancelist}
                        onChange={(val) => {
                          setFormData({
                            ...formData,
                            appliance_id: val.value,
                          });
                        }}
                      />
                    </div>
                  </div>
                  <div className="col-md-2">
                    <div className="form-group">
                      <label>
                        Call Type{" "}
                        <span style={{ color: "red" }}>
                          {formErrors.calltype_id}
                        </span>
                      </label>
                      <Select
                        name="calltype"
                        menuPortalTarget={document.body}
                        menuPosition="fixed"
                        value={
                          calltypelist.find(
                            (option) => option.value === formData.calltype_id,
                          ) || null
                        }
                        options={calltypelist}
                        onChange={(val) => {
                          setFormData({
                            ...formData,
                            calltype_id: val.value,
                          });
                        }}
                      />
                    </div>
                  </div>

                  <div className="col-md-2">
                    <div className="form-group">
                      <label>
                        State{" "}
                        <span style={{ color: "red" }}>
                          {formErrors.state_id}
                        </span>
                      </label>
                      <Select
                        name="state_id"
                        menuPortalTarget={document.body}
                        menuPosition="fixed"
                        value={
                          stateList.find(
                            (option) => option.value === formData.state_id,
                          ) || null
                        }
                        options={stateList}
                        onChange={(val) => {
                          setFormData({
                            ...formData,
                            state_id: val.value,
                          });
                        }}
                      />
                    </div>
                  </div>
                  <div className="col-md-2">
                    <div className="form-group">
                      <label>
                        Sort By{" "}
                        <span style={{ color: "red" }}>
                          {formErrors.order_by}
                        </span>
                      </label>
                      <Select
                        name="order_by"
                        menuPortalTarget={document.body}
                        menuPosition="fixed"
                        value={
                          sortFilter.find(
                            (option) => option.value === formData.order_by,
                          ) || null
                        }
                        options={sortFilter}
                        onChange={(val) => {
                          setFormData({
                            ...formData,
                            order_by: val.value,
                          });
                        }}
                      />
                    </div>
                  </div>
                  <div className="col-md-1">
                    <div className="form-group">
                      <label>
                        .{" "}
                        <span style={{ color: "red" }}>
                          {formErrors.submit}
                        </span>
                      </label>
                      <input
                        name="submit"
                        id="submit"
                        type="submit"
                        className="form-control btn btn-primary"
                        onClick={() => {
                          setReload(true);
                        }}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>
      </section>
    );
  };

  const calculateDateDifference = (givenDate) => {
    const currentDate = new Date();
    const selectedDate = new Date(givenDate);

    // Calculate the difference in milliseconds
    const differenceInMilliseconds = Math.abs(selectedDate - currentDate);

    // Calculate the difference in days
    const differenceInDays = Math.floor(
      differenceInMilliseconds / (1000 * 60 * 60 * 24),
    );

    return differenceInDays;
  };

  const columns = [
    {
      name: "SNo.",
      selector: (row) => "", // Placeholder, as we don't need to select data from the row itself
      cell: (row, index) => (
        <>
          {index + 1} &nbsp;{" "}
          {row?.booking_upcountry?.is_upcountry === 1 && (
            <i className="fa fa-road" style={{ color: "red" }}></i>
          )}
        </>
      ),
    },
    {
      name: "Booking ID",
      selector: (row) => row.booking_id,
      cell: (row) => (
        <NavLink to={`/getbookingdetails?bid=${btoa(row.id)}`}>
          {row.booking_id}
        </NavLink>
      ),
    },
    {
      name: <div className="word-wrap">Customer Name / Mobile No</div>,
      wrap: true,
      selector: (row) =>
        row.user_detail["customer_name"] +
        "/ " +
        row.booking_primary_mobile_number,
      cell: (row) => (
        <div className="word-wrap">
          {row.user_detail["customer_name"]}
          <br />
          <NavLink to={`/search?keyword=${row.booking_primary_mobile_number}`}>
            {row.booking_primary_mobile_number}
          </NavLink>
        </div>
      ),
    },
    {
      name: <div className="word-wrap">{LABEL_APPLIACE_NAME}</div>,
      selector: (row) =>
        row.appliance["appliance_name"] + "/ " + row.calltype_group["type"],
      wrap: true,
    },
    {
      name: <div className="word-wrap">{LABEL_BRAND}</div>,
      selector: (row) =>
        row.user_appliance_detail["brand"].brand_name +
        "/" +
        row.user_appliance_detail["category"].category_name,
      cell: (row) => (
        <div className="word-wrap">
          {`${row.user_appliance_detail["brand"].brand_name}
               /
               ${row.user_appliance_detail["category"].category_name}`}
        </div>
      ),
    },
    {
      name: <div className="word-wrap">{LABEL_JOB + " Date"}</div>,
      selector: (row) => moment(row.booking_date).format("DD-MMM-YYYY"),
      cell: (row) => (
        <div className="word-wrap">
          {moment(row.booking_date).format("DD-MMM-YYYY")}
        </div>
      ),
    },
    {
      name: "Ageing",
      selector: (row) =>
        calculateDateDifference(row.booking_initial_date) + " Days",
      cell: (row) =>
        calculateDateDifference(row.booking_initial_date) + " Days",
    },
    {
      name: "Status",
      wrap: true,
      selector: (row) =>
        row.partner_current_status + " / " + row.partner_internal_status,
      cell: (row) => (
        <div className="word-wrap">
          {row.partner_current_status} / <br />
          {row.partner_internal_status}
        </div>
      ),
    },
    Number(loggedInUser.entity_type) === EMPLOYEE_TYPE && {
      name: <div className="word-wrap">Service Center</div>,
      wrap: true,
      selector: (row) => row.service_centre["display_name"],
      cell: (row) => (
        <div className="word-wrap">{row.service_centre["display_name"]}</div>
      ),
    },
    !SF_ACTION_PERMISSION.includes(loggedInUser.role_id) && {
      name: "State",
      wrap: true,
      selector: (row) => row?.state?.state,
      cell: (row) => <div className="word-wrap">{row?.state?.state}</div>,
    },
    {
      name: "Job card",
      cell: (row) => (
        <>
          <button
            target={"_blank"}
            className="booking-table-action-btn"
            onClick={() => {
              openSignUrl(row.jobcard_file);
            }}
          >
            <i className="fas fa-download" />
          </button>
        </>
      ),
      ignoreRowClick: true,
      allowOverflow: true,
      button: true,
      exportXlsx: false,
    },
    (Number(loggedInUser.entity_type) === EMPLOYEE_TYPE ||
      Number(loggedInUser.entity_type) === SF_TYPE) && {
      name: "Pickup/Drop (SC)",
      cell: (row) => (
        <>
          {Number(row?.is_home_visit_repair) === 0 &&
            (!row?.customer_drop_unit_date ? (
              <button
                className="booking-table-action-btn"
                onClick={(e) => {
                  e.preventDefault();
                  setBid(row.id);
                  setNonHomeVisit(1);
                }}
              >
                <i className="fas fa-truck" />
              </button>
            ) : (
              row?.customer_drop_unit_date &&
              !row?.customer_pick_unit_date && (
                <button
                  className="booking-table-action-btn booking-table-action-btn--secondary"
                  onClick={(e) => {
                    e.preventDefault();
                    setBid(row.id);
                    setNonHomeVisit(2);
                  }}
                >
                  <i className="fas fa-ticket" />
                </button>
              )
            ))}
        </>
      ),
      ignoreRowClick: true,
      allowOverflow: true,
      button: true,
      exportXlsx: false,
    },
  ].filter(Boolean);

  return (
    <div>
      <MainBody
        breadcrumbTitle="Appliance Dropped (ASC)"
        breadcrumbSubTitle={"List"}
        navButton={""}
        title={""}
        component={
          <>
            {isFilterOpen && <FilterComponent />}

            <section className="content">
              <div className="container-fluid">
                <div className="row">
                  <div className="col-md-12">
                    <div className="card assign-booking-list-card">
                      <div className="card-header assign-booking-header">
                        <h3 className="card-title">Pending {LABEL_JOB} List</h3>
                        <div
                          className="assign-booking-filter-toggle"
                          style={{ marginLeft: "auto", marginRight: "10px" }}
                          onClick={() => setisFilterOpen(true)}
                          role="button"
                          tabIndex={0}
                          onKeyDown={(e) => {
                            if (e.key === "Enter" || e.key === " ")
                              setisFilterOpen(true);
                          }}
                        >
                          <i className="fas fa-filter" aria-hidden="true"></i>
                        </div>
                      </div>
                      <MyDataTable
                        reloadList={reloadList}
                        columns={columns}
                        getDataListURL={`getpickedappliancesdata?partner_id=${formData.partner_id}&calltype_id=${formData.calltype_id}&appliance_id=${formData.appliance_id}&state_id=${formData.state_id}&order_by=${formData.order_by}`}
                        setReload={setReload}
                        exportName={"pendinglist"}
                      />
                    </div>
                  </div>
                </div>
              </div>
              {isOpenForm && (
                <AssignVendor
                  closeForm={closeForm}
                  setReload={setReload}
                  bid={bid}
                />
              )}

              {isEngOpenForm && (
                <AssignEngineer
                  closeForm={closeForm}
                  setReload={setReload}
                  bid={bid}
                />
              )}

              {isNonHomeVisit > 0 && (
                <CustomerPickDrop
                  closeForm={closeForm}
                  setReload={setReload}
                  bid={bid}
                  action={isNonHomeVisit}
                />
              )}
            </section>
          </>
        }
      />
    </div>
  );
};

export default ApplianceDroppedASC;
